import { render, staticRenderFns } from "./TicketTable.vue?vue&type=template&id=895fe25e&scoped=true&"
import script from "./TicketTable.vue?vue&type=script&lang=ts&"
export * from "./TicketTable.vue?vue&type=script&lang=ts&"
import style0 from "./TicketTable.vue?vue&type=style&index=0&id=895fe25e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895fe25e",
  null
  
)

export default component.exports